import React from 'react';

import { AccountSettingsProvider } from './AccountSettingsContext';
import { CashAccountSettings } from './components/CashAccountSettings';
import { DirectTradingAccountSettings } from './components/DirectTradingAccountSettings';
import { ManagedAccountSettings } from './components/ManagedAccountSettings';

import type { AccountSettingsUrlBuilders, RenderCloseAccountAction, RenderDeletePurposeAction } from './contentTypes';
import type { AccountSettingsAccount } from './data';

export type AccountSettingsModalContentProps = {
  account: AccountSettingsAccount | null | undefined;
  currentPath: string;
  urlBuilders: AccountSettingsUrlBuilders;
  renderDeletePurpose?: RenderDeletePurposeAction;
  renderCloseAccount?: RenderCloseAccountAction;
  clientName?: string;
  showInlineEditLinks?: boolean;
  purposelessCopy?: string;
  handleNameUpdate?: (newName?: string) => Promise<string | null>;
  isEditable?: boolean;
};

export const AccountSettingsModalContent: React.FC<AccountSettingsModalContentProps> = ({
  account,
  currentPath,
  urlBuilders,
  renderDeletePurpose,
  renderCloseAccount,
  clientName,
  showInlineEditLinks,
  purposelessCopy,
  handleNameUpdate,
  isEditable,
}) => {
  if (!account) {
    return null;
  }

  let content: React.ReactElement | null = null;
  switch (account.__typename) {
    case 'CashAccount':
      content = (
        <CashAccountSettings
          currentPath={currentPath}
          urlBuilders={{
            accountDetails: urlBuilders.accountDetails,
            editPortfolio: urlBuilders.editPortfolio,
            editPurpose: urlBuilders.editPurpose,
            legalAccounts: urlBuilders.legalAccounts,
          }}
          purposelessCopy={purposelessCopy}
        />
      );
      break;
    case 'ManagedAccount':
      content = (
        <ManagedAccountSettings
          currentPath={currentPath}
          urlBuilders={urlBuilders}
          renderDeletePurpose={renderDeletePurpose}
          clientName={clientName}
          showInlineEditLinks={showInlineEditLinks}
          purposelessCopy={purposelessCopy}
        />
      );
      break;
    case 'DirectTradingAccount':
      content = (
        <DirectTradingAccountSettings
          urlBuilders={{
            accountDetails: urlBuilders.accountDetails,
            editPortfolio: urlBuilders.editPortfolio,
            legalAccounts: urlBuilders.legalAccounts,
          }}
        />
      );
      break;
    default:
      return null;
  }

  return (
    <AccountSettingsProvider value={{ account, isEditable: isEditable ?? true, handleNameUpdate, renderCloseAccount }}>
      {content}
    </AccountSettingsProvider>
  );
};
